export default ({ store }, inject) => {
  inject('resetStore', () => {
    store.dispatch('call/arrivalTimeValue', 30); // 今から30分後
    store.dispatch('call/arrivalTimeLabel', '30分後'); // 今から30分後
    store.dispatch('call/arrivalDateTimeValue', ''); // 何日何時何分
    store.dispatch('call/nominateCast', ''); // 指名キャスト
    store.dispatch('call/castFree', false); // キャストフリー
  })
}